module.exports = __webpack_public_path__ + "img/header2.00db0c0a.png";